<template>
  <div class="amazon-layout">
    <SizeChartForm />

    <SizeChartResult />
  </div>
</template>

<script setup>
// 删除了 WorkbenchLayout 的引入
import SizeChartForm from "@/components/size-chart/SizeChartForm.vue";
import SizeChartResult from "@/components/size-chart/SizeChartResult.vue";
</script>
